"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Input = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _omit3 = _interopRequireDefault(require("lodash/omit"));

var _Field = require("../Field");

var _BlurInput = _interopRequireDefault(require("../util/BlurInput"));

var _ControlledBlurInput = _interopRequireDefault(require("../util/ControlledBlurInput"));

var Overlay =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Overlay, _React$Component);

  function Overlay() {
    (0, _classCallCheck2["default"])(this, Overlay);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Overlay).apply(this, arguments));
  }

  (0, _createClass2["default"])(Overlay, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          icon = _this$props.icon,
          left = _this$props.left,
          right = _this$props.right,
          id = _this$props.id;
      var input = this.props.children,
          overlayLeft,
          overlayRight,
          overlayClass = '';

      if (icon) {
        overlayLeft = _react["default"].createElement("div", {
          className: "zsg-input-overlay-icon"
        }, _react["default"].createElement("i", {
          className: icon
        }));
        overlayClass += 'zsg-input-overlay_left ';
      } else if (left) {
        overlayLeft = _react["default"].createElement("div", {
          className: "zsg-input-overlay-text_left"
        }, left);
        overlayClass += 'zsg-input-overlay_left ';
      }

      if (right) {
        overlayRight = _react["default"].createElement("div", {
          className: "zsg-input-overlay-text_right"
        }, right);
        overlayClass += 'zsg-input-overlay_right ';
      }

      if (overlayLeft || overlayRight) {
        input = _react["default"].createElement("div", {
          className: overlayClass + id
        }, overlayLeft, input, overlayRight);
      }

      return input;
    }
  }]);
  return Overlay;
}(_react["default"].Component);

Overlay.propTypes = process.env.NODE_ENV !== "production" ? {
  icon: _propTypes["default"].string,
  id: _propTypes["default"].string,
  left: _propTypes["default"].node,
  right: _propTypes["default"].node,
  children: _propTypes["default"].node
} : {}; // Input without the Field for custom components

var Input =
/*#__PURE__*/
function (_React$Component2) {
  (0, _inherits2["default"])(Input, _React$Component2);

  function Input() {
    (0, _classCallCheck2["default"])(this, Input);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Input).apply(this, arguments));
  }

  (0, _createClass2["default"])(Input, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (typeof this.props.debounceMs !== 'number') {
        return true;
      } else {
        return !(0, _isEqual2["default"])(nextProps, this.props);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _omit2 = (0, _omit3["default"])(this.props, 'toolbar'),
          controlled = _omit2.controlled,
          overlayRight = _omit2.overlayRight,
          overlayLeft = _omit2.overlayLeft,
          overlayIcon = _omit2.overlayIcon,
          inputProps = (0, _objectWithoutProperties2["default"])(_omit2, ["controlled", "overlayRight", "overlayLeft", "overlayIcon"]);

      var id = inputProps.id;
      var BlurInputComponent = controlled ? _ControlledBlurInput["default"] : _BlurInput["default"];

      var input = _react["default"].createElement(BlurInputComponent, inputProps); // Wrap in overlay if necessary


      if (overlayRight || overlayLeft || overlayIcon) {
        input = _react["default"].createElement(Overlay, {
          icon: overlayIcon,
          left: overlayLeft,
          right: overlayRight,
          id: id
        }, input);
      }

      return input;
    }
  }]);
  return Input;
}(_react["default"].Component);

exports.Input = Input;
Input.displayName = 'InputField';
Input.propTypes = process.env.NODE_ENV !== "production" ? {
  id: _propTypes["default"].string,
  value: _propTypes["default"].string,

  /**
   * Class name for an overlay with an icon in the input field on the left side
   */
  overlayIcon: _propTypes["default"].string,

  /**
   * overlay wrapped in the input field on the left side
   */
  overlayLeft: _propTypes["default"].node,

  /**
   * overlay wrapped in the input field on the right side
   */
  overlayRight: _propTypes["default"].node,

  /**
   * Fire onChange event after this many ms.
   */
  debounceMs: _propTypes["default"].number,

  /**
   * input placeholder text
   */
  placeholder: _propTypes["default"].string,

  /**
   * set to true to receive onChange after every key press (normally fires on blur or debounce)
   */
  controlled: _propTypes["default"].bool,

  /**
   * By default, inputs will not rerender a new `value` prop while the input has focus;
   * this is to prevent the value from unexpectedly changing while you are actively editing it.
   * If you would like the input to remain controlled even while the input has focus (uncommon),
   * set this to `true`.
   */
  controlledEditing: _propTypes["default"].bool,

  /**
   * Passed when this component is composed (nested) inside of a <Toolbar>
   */
  toolbar: _propTypes["default"].bool,

  /**
   * Autocomplete type for browser. Browsers inconsistently trigger input change on browser autofill.
   * By default autofill won't trigger React input change. If this prop is set to a value
   * other than 'off', the value of the DOM input will be regularly synced with what React stores
   * in state. MDN entry on input autocomplete attribute: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-autocomplete
   */
  autoComplete: _propTypes["default"].string
} : {};
Input.defaultProps = {
  controlled: false,
  controlledEditing: false
};
var InputField = (0, _Field.wrap)(Input);
var _default = InputField;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/InputField/index.js
// module id = 349
// module chunks = 0